import { motion } from 'framer-motion';

import { styled } from '@/style';

import CloseIcon from '../assets/Close.svg';

export const Container = styled(motion.div)<{
  fullSize?: boolean;
}>`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: secondaryText;
  z-index: overlay;
  overflow-y: scroll;
  background-color: transparent;
  min-height: 100vh;
  background-color: primary;
`;
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: background;
`;
export const CloseButton = styled(CloseIcon)`
  position: fixed;
  z-index: foreground;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  margin-top: lg;
  margin-right: lg;
  cursor: pointer;
`;
export const Content = styled(motion.div)`
  position: relative;
  width: 100%;
  margin: auto;
  background: transparent;
  z-index: infront;
  min-height: 100vh;
`;

export const animations = {
  container: {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  },
  content: {
    visible: {
      top: 0,
    },
    hidden: {
      top: 10,
    },
  },
};
